import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as ItemButton } from "assets/icons/topbar_item_button.svg";
import { ReactComponent as BellIcon } from "assets/icons/bell.svg";
import { ReactComponent as ListIcon } from "assets/icons/list.svg";
import PriceFilter from "./PriceFilter";
import SurfaceFilter from "./SurfaceFilter";
import RoomFilter from "./RoomFilter";
import BedroomFilter from "./BedroomFilter";
import BathroomsFilter from "./BathroomsFilter";
import FloorFilter from "./FloorFilter";
import SortByFilter from "./SortByFilter";
import PropertyTypeFilter from "./PropertyTypeFilter";
import SearchSaveDialog from "components/Dialog/SearchSaveDialog";
import SearchMobileFilterDialog from "components/Dialog/SearchMobileFilterDialog";
import useProperties from "hooks/useProperties";
import useDialog from "hooks/useDialog";
import useAuth from "hooks/useAuth";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { ReactComponent as ArrowRightIcon } from "assets/icons/slider_arrow_right.svg";
import { useMediaQuery } from "react-responsive";
import useSearchFilter from "hooks/useSearchFilter";
import HousePriceCalculatorDialog from "components/Dialog/HousePriceCalculatorDialog";
import useSearch from "hooks/useSearch";
import SearchInput from "./SearchInput";
import { toast } from "react-toastify";
import useSubscription from "hooks/useSubscription";

const SearchHeader = () => {
  const [isSaveSearchDialogOpen, setIsSaveSearchDialogOpen] = useState(false);
  const { toggleHousePriceCalculatorDialog } = useSearchFilter();
  const { user } = useAuth();
  const { openSigninDialog } = useDialog();
  const { subscriptionStatus } = useSubscription();
  const lg = useMediaQuery({ query: "(min-width: 1024px)" });

  // Slider settings
  const settings = {
    modules: [Pagination, Navigation],
    slidesPerView: "auto",
    pagination: false,
    freeMode: true,
    navigation: {
      nextEl: ".filter-swiper-button-next",
      prevEl: ".filter-swiper-button-prev",
    },
    spaceBetween: 9,
  };

  const handleSaveSearch = () => {
    if (user) {
      if (subscriptionStatus.hasPremium) {
        setIsSaveSearchDialogOpen(true);
      } else {
        toast.error(
          "Per salvare la ricerca, devi essere abbonato al piano Pro"
        );
      }
    } else {
      openSigninDialog();
    }
  };

  return (
    <>
      {lg ? (
        <div className="hidden lg:inline-flex h-[76px] w-full items-center space-x-3 px-6 border-b border-[#E2E4E9]">
          {/* Search input and suggestion dropdown  */}
          <SearchInput />
          <Swiper className="search_filter_slider" {...settings}>
            {/* Property type filter  */}
            <SwiperSlide>
              <PropertyTypeFilter />
            </SwiperSlide>

            {/* Price filter  */}
            <SwiperSlide>
              <PriceFilter />
            </SwiperSlide>

            {/* Surface filter */}
            <SwiperSlide>
              <SurfaceFilter />
            </SwiperSlide>

            {/* Room Filter  */}
            <SwiperSlide>
              <RoomFilter />
            </SwiperSlide>

            {/* Bedrooms Filter  */}
            <SwiperSlide>
              <BedroomFilter />
            </SwiperSlide>

            {/* Bathrooms Filter  */}
            <SwiperSlide>
              <BathroomsFilter />
            </SwiperSlide>

            {/* Floor Filter  */}
            <SwiperSlide>
              <FloorFilter />
            </SwiperSlide>

            <SwiperSlide>
              <div
                onClick={() =>
                  toggleHousePriceCalculatorDialog("searchCalculator")
                }
                className="cursor-pointer w-[42px] h-[42px] flex items-center justify-center  rounded-[8px] border-[1.5px] border-[#F0EFFB]"
              >
                <ItemButton />
              </div>
            </SwiperSlide>
            <div className="filter-swiper-button-prev absolute left-0 z-[51] top-1/2 shadow-md -translate-y-1/2 bg-primary rounded-full cursor-pointer w-[30px] h-[30px] grid place-items-center transform rotate-180">
              <ArrowRightIcon width={14} height={25} fill="white" />
            </div>
            <div className="filter-swiper-button-next absolute right-0 z-50 top-1/2 shadow-md transform -translate-y-1/2 bg-primary rounded-full cursor-pointer w-[30px] h-[30px] grid place-items-center">
              <ArrowRightIcon width={14} height={25} fill="white" />
            </div>
          </Swiper>

          {/* Header right  */}
          <div className="flex items-center space-x-[25px] min-w-fit">
            <div className="text-[#373C47] flex text-[14px] font-medium leading-[1.2] items-center space-x-1">
              <p className="font-bold flex-shrink-0">Ordina per</p>
              <SortByFilter />
            </div>
            <div
              onClick={handleSaveSearch}
              className="flex items-center justify-center space-x-[6px] cursor-pointer bg-[#FF6D59] rounded-[8px] h-[42px] w-[141px] hover:opacity-90 transition-all duration-300"
            >
              <BellIcon />
              <p className="text-[12px] flex-shrink-0 font-semibold leading-[30px] text-white">
                Salva la Ricerca
              </p>
            </div>
          </div>

          <HousePriceCalculatorDialog id="searchCalculator" />
          <SearchSaveDialog
            isOpen={isSaveSearchDialogOpen}
            onClose={() => setIsSaveSearchDialogOpen(false)}
          />
        </div>
      ) : (
        <SearchMobileFilterDialog />
      )}
    </>
  );
};

export default SearchHeader;
